// extracted by mini-css-extract-plugin
export default {"error":"Error_error__pLcbZ","icon":"Error_icon__1DjmT"};